var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.467 8C16.467 12.4183 12.8853 16 8.46698 16C4.0487 16 0.46698 12.4183 0.46698 8C0.46698 3.58172 4.0487 0 8.46698 0C12.8853 0 16.467 3.58172 16.467 8ZM2.06698 8C2.06698 11.5346 4.93236 14.4 8.46698 14.4C12.0016 14.4 14.867 11.5346 14.867 8C14.867 4.46538 12.0016 1.6 8.46698 1.6C4.93236 1.6 2.06698 4.46538 2.06698 8Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46698 0C9.72946 1.5055e-08 10.974 0.298792 12.0989 0.871948C13.2238 1.4451 14.197 2.27635 14.9391 3.29772C15.6812 4.31909 16.171 5.50158 16.3685 6.74852C16.566 7.99546 16.4656 9.27144 16.0754 10.4721C15.6853 11.6728 15.0165 12.7641 14.1238 13.6569C13.2311 14.5496 12.1398 15.2183 10.9391 15.6085C9.73843 15.9986 8.46245 16.099 7.21551 15.9015C5.96857 15.704 4.78607 15.2142 3.7647 14.4721L4.70516 13.1777C5.52225 13.7714 6.46825 14.1632 7.4658 14.3212C8.46335 14.4792 9.48414 14.3989 10.4447 14.0868C11.4052 13.7747 12.2783 13.2397 12.9925 12.5255C13.7066 11.8113 14.2416 10.9383 14.5537 9.97771C14.8658 9.01715 14.9462 7.99637 14.7882 6.99882C14.6302 6.00127 14.2383 5.05527 13.6447 4.23817C13.051 3.42108 12.2724 2.75608 11.3725 2.29756C10.4726 1.83903 9.47697 1.6 8.46698 1.6V0Z",
    fill: "#517DDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoader);
export default __webpack_public_path__ + "static/media/IconLoader.7640d2cc68fb48b9cb7121bdb41b48f3.svg";
export { ForwardRef as ReactComponent };